// extracted by mini-css-extract-plugin
export var details = "_g1-0";
export var inspectorPopover = "_g1-1";